module.exports = {"username":"Usuario","password":"Contraseña","logIn":"Ingresar","allRightsReserved":"{name} © Derechos reservados {date}","noMatch":"El nombre de usuario y la contraseña no coinciden"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/es.json
// module id = 814
// module chunks = 0